import { useEffect, useState } from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import api from "@/lib/api";

export default function FAQ({ limit }) {
    const [faqs, setFaqs] = useState([]);
    useEffect(() => {
        api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
    }, []);
    const list = limit ? faqs.slice(0, limit) : faqs;

    return (
        <section className="section" data-testid="faq-section">
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <p className="eyebrow">Frequently Asked</p>
                        <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3">
                            Everything you wanted to ask about <span className="italic text-[#003E4D]">Styletto IX.</span>
                        </h2>
                        <p className="mt-5 text-[15px] text-[#4a5568] leading-relaxed max-w-[400px]">
                            Couldn't find your answer? Tap the WhatsApp button below — a HearClear audiologist will respond personally.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                            {list.map((f, i) => (
                                <AccordionItem
                                    key={f.id}
                                    value={`item-${i}`}
                                    className="border-b border-[#E5E7EB]"
                                    data-testid={`faq-item-${i}`}
                                >
                                    <AccordionTrigger className="text-left font-serif text-[20px] md:text-[22px] py-5 text-[#1a1a1a] hover:no-underline">
                                        {f.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-[15px] text-[#4a5568] leading-relaxed pb-5 pr-4">
                                        {f.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
